import React, { useState } from "react";
import BaseModal from "./BaseModal";
import { loginRestaurant } from "../../api/restaurantApi";
import { useNavigate } from "react-router-dom";

/**
 * A modal component for the login interface, extending BaseModal to include specific elements for user login.
 *
 * @component
 * @param {Boolean} isOpen - Controls whether the modal is open or closed.
 * @param {Function} onRequestClose - Callback function triggered to close the modal, passed down to BaseModal.
 * @param {Function} toggleView - Callback function triggered when the user clicks the sign up button, allowing switching to SignUpModal.
 * @param {String} [width='auto'] - Optional width of the modal content, defaults to 'auto' if not provided.
 *
 * @returns {JSX.Element} The rendered LoginModal component.
 */
const LoginModal = ({ isOpen, onRequestClose, toggleView, width }) => {
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const response = await loginRestaurant(
        formData.email,
        formData.password,
        window.location.pathname,
      );
      const restaurant = response.restaurant;
      localStorage.setItem("authToken", response.token);
      localStorage.setItem("restaurant", JSON.stringify(restaurant));
      onRequestClose();
      navigate(`/admin/restaurant/${restaurant.id}/menu/${restaurant.menu.id}`);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <BaseModal isOpen={isOpen} onRequestClose={onRequestClose} width={width}>
      <div className="base-modal">
        <div className="base-modal-header">
          <div className="base-modal-company-logo">
            <img src="/logo.png" alt="tastelens" />
            <h1>welcome back</h1>
          </div>
          <h2>glad to see you again!</h2>
          <h2>login to your account below</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <label htmlFor="login-email">email</label>
          <input
            type="text"
            id="login-email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="enter email"
            required
          />
          <br />
          <label htmlFor="login-password">password</label>
          <input
            type="password"
            id="login-password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            placeholder="enter password"
            required
          />
          <br />
          <button type="submit">login</button>
        </form>
        <div className="base-modal-toggle">
          <h3>don't have an account?</h3>
          <button onClick={toggleView}>sign up</button>
        </div>
      </div>
    </BaseModal>
  );
};

export default LoginModal;
